import { FIRM } from "@/lib/firm";

/** Page-specific enquiry buttons shown under a page heading. Jumps to the page's enquiry form. */
export function EnquiryCta({ label, href = "#enquiry", phone = FIRM.phone, phoneHref = FIRM.phoneHref }: { label: string; href?: string; phone?: string; phoneHref?: string }) {
  return (
    <div className="mt-8 flex flex-wrap items-center gap-3">
      <a
        href={href}
        className="inline-flex min-h-12 items-center justify-center rounded-sm bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
      >
        {label}
      </a>
      <a
        href={phoneHref}
        className="inline-flex min-h-12 items-center justify-center rounded-sm border border-border bg-background px-6 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-secondary"
      >
        Call {phone}
      </a>
    </div>
  );
}
